// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__C9gOW","loading_text":"Overlay_loading_text__P0Fda","glow":"Overlay_glow__53TRf"};